import { db } from "../../../config/firebase/firebase-config";
import { ITrdSubSerie } from "../../../redux/types/types";
import { getTrdSeries } from "./serieService";
import {IAppendDoc, IDigitalSupport} from "../../../interfaces/Correspondence";
// --------------------------------------------------------
// -------------------- Sub-Series ------------------------
// --------------------------------------------------------

// Cargar Subserie
export const loadSubseries = async (idEntity: string) => {
  const docRef = db.collection("Entities").doc(idEntity).collection("Series");

  const series = await getTrdSeries(idEntity);

  // hacer consulta interna de cada serie
  if (series.length > 0) {
    const subSeriesARR: any = [];
    for (let values of series) {
      let subSeriesSnap = await docRef
        .doc(values.idSerie)
        .collection("SubSeries")
        .get();
      subSeriesSnap.forEach((snapChild) => {
        subSeriesARR.push({
          id: snapChild.id,
          ...snapChild.data(),
        });
      });
    }
    return subSeriesARR;
  }

  return null;
};

// Actualizar array de oficinas productoras en TRD versión
export const updateArraySubseries = async (
  idEntity: string,
  idVersion: string,
  subseries: string[]
) => {
  try {
    await db
      .collection("Entities")
      .doc(idEntity)
      .collection("TRD")
      .doc(idVersion)
      .set(
        {
          subseries: subseries.length > 0 ? subseries : null,
        },
        {
          merge: true,
        }
      );
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

// Borrar subserie
export const deleteSubserieFirebase = async (
  idEntity: string,
  idSerie: string,
  idSubserie: string
) => {
  try {
    await db
      .collection("Entities")
      .doc(idEntity)
      .collection("Series")
      .doc(idSerie)
      .collection("SubSeries")
      .doc(idSubserie)
      .delete();
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

// validar sub-serie
export const existsSubserie = async (
  idEntity: string,
  idVersion: string,
  idSerie: string,
  code: string,
  name: string,
  edit: boolean
) => {
  let subSerie: any[] = [];
  const refProduction = db
    .collection("Entities")
    .doc(idEntity)
    .collection("Series")
    .doc(idSerie)
    .collection("SubSeries");

  if (!edit) {
    const subSerieCodeSnap = await refProduction
      .where("idVersion", "==", idVersion)
      .where("subSerieCode", "==", code)
      .get();
    subSerieCodeSnap.forEach((snap) => {
      subSerie.push({
        id: snap.id,
        ...snap.data(),
      });
    });
  }

  const subSerieNameSnap = await refProduction
    .where("idVersion", "==", idVersion)
    .where("name", "==", name)
    .get();
  subSerieNameSnap.forEach((snap) => {
    subSerie.push({
      id: snap.id,
      ...snap.data(),
    });
  });

  return subSerie;
};

// Agregar Sub-serie
export const addOrUpdateSubserie = async (
  idEntity: string,
  idSerie: string,
  subSerie: ITrdSubSerie
) => {
  try {
    await db
      .collection("Entities")
      .doc(idEntity)
      .collection("Series")
      .doc(idSerie)
      .collection("SubSeries")
      .doc(subSerie.idSubserie)
      .set(subSerie, { merge: true });
    return {
      ok: true,
    };
  } catch (error) {
    return {
      ok: false,
      data: error,
    };
  }
};

export const checkIfSubserieUsedInCorrespondence = async (
  idEntity: string,
  idSubserie: string
): Promise<boolean> => {
  try {
    const snapshot = await db
      .collection("Correspondence")
      .doc(idEntity)
      .collection("CorrespondenceSection")
      .get();

    for (const doc of snapshot.docs) {
      const data = doc.data() as any;
      const digitalSupport = data.digitalSupport as IDigitalSupport[];

      if (Array.isArray(digitalSupport)) {
        for (const support of digitalSupport) {
          const trdCodes = support.trdCode;

          if (Array.isArray(trdCodes)) {
            for (const trd of trdCodes) {
              const subserieId = trd?.subserie?.id;
              if (subserieId === idSubserie) {
                return true;
              }
            }
          }
        }
      }

      const appendDocs = data.appendDocs as IAppendDoc[];
      if (Array.isArray(appendDocs)) {
        for (const append of appendDocs) {
          const trdCodes = append.trdCode;
          if (Array.isArray(trdCodes)) {
            for (const trd of trdCodes) {
              const subserieId = trd?.subserie?.id;
              if (subserieId === idSubserie) {
                return true;
              }
            }
          }
        }
      }
    }

    return false;
  } catch (error) {
    console.error("[ERROR] checkIfSubserieUsedInCorrespondence:", error);
    return false;
  }
};